import React, { Component } from 'react';
import { connect } from "react-redux";

import { lang } from '../config/lang';
import $ from "jquery/dist/jquery.js";
import { withRouter } from 'react-router-dom';
import store from '../store/configureStore';
import { addNotification } from "../actions/notificationAction";
import { setSearchKeyAction } from '../actions/topBannerAction';
import { setGlobalSearchKeyAction } from '../actions/searchAction';


/****************************************
    Component for Top Banner of a page
    @author  IMH003
    @date    2020.05.14
    @version 0.1    
 ******************************************/
class HeaderSearchBox extends Component {

    constructor(props) {
        super(props);
        this.onSearch = this.onSearch.bind(this);
        this.handleKeyPress = this.handleKeyPress.bind(this);
        this.checkSearchKey = this.checkSearchKey.bind(this);
        this.handleOnChange = this.handleOnChange.bind(this);
    }

    componentWillMount() {
        this.setState({

        });
    }

    componentDidMount() {
    }

    componentWillUnmount() {
    }

    componentWillReceiveProps(newProps) {
        this.forceUpdate();
    }

    onSearch() {
        this.props.onSearch($('#header_search_box').val().trim());
    }

    checkSearchKey(str) {
        var patt = new RegExp(/[@#!$%^&*~{}|><"/+_()]/g);
        if(str === '' || str.indexOf(' ') === 0) return false;
        if (patt.test(str)) {
            return false;
        } else {
            return true;
        }
    };

    handleOnChange(e) {
        store.dispatch(setGlobalSearchKeyAction(e.target.value));
    };

    handleKeyPress(event) {
        if (event.key === "Enter") {
            var search = this.checkSearchKey(this.props.global.searchKey);
            if (search) {
                this.props.history.push("/search" + "?" + "keyword=" + this.props.global.searchKey);
                store.dispatch(setSearchKeyAction(this.props.global.searchKey));
            }
            else store.dispatch(addNotification(`${lang('search_key_err')}`, 'error'));
            store.dispatch(setSearchKeyAction(this.props.global.searchKey))
            this.onSearch();
        }
    }

    render() {
        return (
            <div className="header-search">
                <div className="form-group">
                    <span className="fa fa-search icon-search"></span>
                    <input type="text" className="header-form-control search-input" placeholder={`${lang('search')}...`} id="header_search_box" onKeyPress={this.handleKeyPress} onChange={this.handleOnChange} value={this.props.global.searchKey} />
                </div>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        language: state.language,
        global: state.globalSearch,
    };
}

export default withRouter(connect(mapStateToProps)(HeaderSearchBox));